export const adjustPerformersData = () => {
  return [
    {
      name: 'ЗАО «Очень длинное название фи…',
      subject: 'ЮЛ',
      status: {
        statusKey: 'nonactive',
        name: 'Неактивный',
        data: '05.04.2019',
      },
      email: 'VeryLong@mail.com',
      orders: {
        plainOrders: 7,
        archiveOrders: 0,
      },
      data: {
        changeData: '05.04.2019',
        creationData: '03.02.2019',
      },
    },
    {
      name: 'ИП Заец Максим Васильевич',
      subject: 'ИП',
      status: {
        statusKey: 'nonactive',
        name: 'Неактивный',
        data: '05.05.2019',
      },
      email: 'konstBA@mail.com',
      orders: {
        plainOrders: 2,
        archiveOrders: 0,
      },
      data: {
        changeData: '05.05.2019',
        creationData: '03.03.2019',
      },
    },
  ];
};
